import React from 'react';
import { Box, Typography } from '@mui/material';
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined';
import { formatPartnerEventArchivedAt } from '../partnerEventArchive';

const PartnerArchivedEventNotice = ({ archivedAt }) => {
  const dateLabel = formatPartnerEventArchivedAt(archivedAt);

  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 1.5,
        mb: 2,
        p: { xs: 1.5, sm: 2 },
        borderRadius: 2,
        border: '1px solid #e8dfd6',
        bgcolor: '#f9f7f5',
      }}
    >
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: 1.5,
          bgcolor: 'background.paper',
          border: '1px solid #ede4dc',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <ArchiveOutlinedIcon sx={{ fontSize: 22, color: '#8b6914' }} />
      </Box>
      <Box sx={{ minWidth: 0, pt: 0.15 }}>
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: '0.95rem',
            color: '#3d3429',
            lineHeight: 1.35,
            mb: 0.35,
          }}
        >
          Archived event
          {dateLabel ? (
            <Box component="span" sx={{ fontWeight: 500, color: '#6b5d52' }}>
              {' '}
              · {dateLabel}
            </Box>
          ) : null}
        </Typography>
        <Typography sx={{ fontSize: '0.875rem', lineHeight: 1.5, color: '#5c534a' }}>
          You can review this event and its guest list, but changes are disabled. Open the{' '}
          <Box component="span" sx={{ fontWeight: 600 }}>
            Archived
          </Box>{' '}
          tab in Events to find it again.
        </Typography>
      </Box>
    </Box>
  );
};

export default PartnerArchivedEventNotice;
